import { useTranslation } from 'react-i18next'

export function IntroSection() {
  const { t } = useTranslation('common')

  return (
    <section className="py-16 md:py-24 bg-[#FDF8F3] relative">
      <div className="container-fiorucci">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <span className="text-[#DF631E] text-sm font-semibold tracking-widest uppercase mb-4 block">
              Chi Siamo
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#4E2118] mb-6 leading-tight">
              {t('about.intro.title')}
            </h2>
            <div className="space-y-6 text-[#4E2118]/80 text-lg leading-relaxed">
              <p>{t('about.intro.paragraph1')}</p>
              <p>{t('about.intro.paragraph2')}</p>
            </div>

            {/* Decorative element */}
            <div className="mt-8 flex items-center gap-4">
              <div className="h-px flex-1 bg-[#DF631E]/30" />
              <span className="text-[#DF631E] text-4xl font-serif italic">1850</span>
              <div className="h-px flex-1 bg-[#DF631E]/30" />
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              {/* Main image */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="/images/about/mondo_fiorucci_Intro_1338x472_DESKTOP.jpg"
                  alt="Fiorucci - Tradizione norcina dal 1850"
                  className="w-full aspect-product object-cover"
                />
                {/* Subtle overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#4E2118]/20 to-transparent" />
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border-2 border-[#DF631E]/30 rounded-2xl -z-10" />
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-[#DF631E]/10 rounded-full -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
